var map = {
	"./screen1.jpg": 213,
	"./screen2.png": 214,
	"./screen3.png": 215,
	"./screen4.png": 216,
	"./screen5.png": 217,
	"./screen6.png": 218,
	"./screen7.png": 219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 212;